module.exports = __webpack_public_path__ + "static/media/stockhausen_haut_27.4baa83d0.jpg";